import React from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { contactInfo } from '../../data/home';

/** Floating WhatsApp shortcut. Hidden where a sticky buy bar occupies the bottom edge. */
export function WhatsAppButton() {
  const {
    pathname
  } = useLocation();
  if (pathname.startsWith('/product') || pathname === '/cart') return null;
  return <a href={contactInfo.whatsappHref} target="_blank" rel="noreferrer" className="fixed bottom-5 left-5 z-40 flex h-12 items-center gap-2 rounded-full bg-[#0E7A4B] pl-3.5 pr-5 text-sm font-bold text-white shadow-[0_12px_32px_-10px_rgba(14,26,36,0.5)] transition-transform duration-150 hover:-translate-y-0.5" aria-label="Stel je vraag via WhatsApp" data-id="element-354" data-mp="1mhonr91n7w69">
      <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-355" data-mp="21la12snopuk" />
      <span className="hidden sm:inline" data-id="element-356" data-mp="23ejsqykfq6s">WhatsApp</span>
    </a>;
}